// @ts-nocheck







import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { downloadRequestWithToken, fetchRequest } from './index';

export const convertDataToServer = (
vehicleMonitoringCalculation) => (
{
  ...vehicleMonitoringCalculation,
  sum: convertFromRubToKop(vehicleMonitoringCalculation.sum),
  months: vehicleMonitoringCalculation.months.map(
    convertDataToServerVehicleMonitoringCalculationMonth
  )
});

export const convertDataFromServer = (
vehicleMonitoringCalculation) => (
{
  ...vehicleMonitoringCalculation,
  sum: convertFromKopToRub(vehicleMonitoringCalculation.sum),
  months: vehicleMonitoringCalculation.months.map(
    convertDataFromServerVehicleMonitoringCalculationMonth
  )
});

export const convertDataToServerVehicleMonitoringCalculationMonth = (
vehicleMonitoringCalculationMonth) => (
{
  ...vehicleMonitoringCalculationMonth,
  cost: convertFromRubToKop(vehicleMonitoringCalculationMonth.cost)
});

export const convertDataFromServerVehicleMonitoringCalculationMonth = (
vehicleMonitoringCalculationMonth) => (
{
  ...vehicleMonitoringCalculationMonth,
  cost: convertFromKopToRub(vehicleMonitoringCalculationMonth.cost)
});

const basedUrl = 'vehicleMonitoringCalculation';
const vehicleMonitoringCalculation = new CommonApi(
  basedUrl,
  'расчет потребности в замене GPS',
  convertDataToServer,
  convertDataFromServer
);

const calculate = async (vehiclePlanId) => {
  const updated = await fetchRequest.put(
    `/${basedUrl}/calculate/${vehiclePlanId}`
  );
  if (updated) return updated;
  throw new Error(`Не удалось произвести расчет`);
};

const changeStatus = async (
vehiclePlanId,
status) =>
{
  const updated = await fetchRequest.put(`/${basedUrl}/changeStatus`, {
    vehiclePlanId,
    status
  });
  if (updated) return updated;
  throw new Error(`Не удалось сменить статус расчет`);
};

const print = async (vehiclePlanId, filter) => {
  const printed = await downloadRequestWithToken(`/${basedUrl}/print`, {
    ...filter,
    vehiclePlanId
  });
  if (printed) return printed;
  throw new Error('Не удалось загрузить файл');
};

export default {
  ...vehicleMonitoringCalculation,
  calculate,
  changeStatus,
  print
};
